import React from 'react';
import MainMenu from '../../components/public/MainMenu';

const PublicMenuPage = () => {
    return <MainMenu />;
};

export default PublicMenuPage;
